import {
  productTypeKey,
  statusKey,
  sideKey,
} from '../../../lib/shared-value-keys';

export const caseHistoryKey = [
  { label: 'Case ID', varName: 'CRID' },
  { label: 'Open Date', varName: 'StatusDate', valueMask: 'date' },
  { label: 'Status', varName: 'StatusName' },
];

export const repInfoKey = [
  { label: 'Rep Name', varName: 'RepName' },
  { label: 'Unit', varName: 'UnitID' },
  { label: 'RB Processed Date', varName: 'ProcessedDate', valueMask: 'date' },
  {
    label: 'Status',
    varName: 'ReviewStatus',
    key: statusKey,
  },
  { label: 'Reviewer ID', varName: 'ReviewerID' },
];

export const keyMetricsKey = [
  {
    label: 'Total Client Assets',
    varName: 'TotalClientAssets',
    valueMask: 'currency',
  },
  {
    label: 'Top Product Type',
    varName: 'TopProductHolding',
  },
  {
    label: 'Top Mutual Fund',
    varName: 'TopMFHolding',
  },
  {
    label: 'Top Annuity',
    varName: 'TopAnnHolding',
  },
  {
    label: 'VA Weight',
    varName: 'PercAnnVAs',
    valueMask: 'percent',
  },
  {
    label: 'Top TM Alert',
    varName: 'MostCommonTradeAlert',
  },
  {
    label: 'Top AM Alert',
    varName: 'MostCommonAccountAlert',
  },
  {
    label: 'Avg. Client Age',
    varName: 'AverageClientAge',
    valueMask: 'integer',
  },
  {
    label: 'New Accounts (Last 30 Days)',
    varName: 'NewAccountsCount',
  },
  {
    label: 'Accounts Opened (Last Year)',
    varName: 'YTDAccountsCount',
  },
  {
    label: 'Total Accounts Managed',
    varName: 'AccountsManagedCount',
  },
];

export const tradeHistoryKey = [
  { label: 'Account #', varName: 'AccountNumDisplay' },
  { label: 'Trade Date', varName: 'TradeDate', valueMask: 'date' },
  {
    label: 'Side',
    varName: 'Side',
    key: sideKey,
  },
  {
    label: 'Product Type',
    varName: 'ProductType',
    key: productTypeKey,
  },
  { label: 'Security ID', varName: 'SecID' },
  { label: 'Product Name', varName: 'ProductName' },
  { label: 'Amount', varName: 'Amount', valueMask: 'currency' },
  { label: 'Rep Code', varName: 'RepCode' },
  {
    label: 'Commission ($)',
    varName: 'CommissionDollars',
    valueMask: 'currency',
  },
];

export const allClientAccountsKey = [
  {
    label: 'Account Number',
    varName: 'AccountNumDisplay',
    decryptTarget: 'EncryptedAccountID',
  },
  { label: 'Owner', varName: 'OwnerName' },
  { label: 'Owner Age', varName: 'OwnerAge' },
  { label: 'Account Type', varName: 'AccountTypeDisplay' },
  { label: 'Registration', varName: 'Registration' },
  { label: 'Tax Status', varName: 'TaxStatus' },
  { label: 'Balance ($)', varName: 'Balance' },
  { label: 'Objective', varName: 'Objective' },
  { label: 'Risk Tolerance', varName: 'RiskTolerance' },
  { label: 'Time Horizon', varName: 'TimeHorizon' },
  { label: 'Open Date', varName: 'OpenDate', valueMask: 'date' },
];

export const repReviewKey = [
  {
    label: 'Date Updated',
    varName: 'DateUpdated',
    valueMask: 'date',
  },
  {
    label: 'Status',
    varName: 'NewStatus',
    key: statusKey,
  },
  {
    label: 'Reviewer ID',
    varName: 'ReviewerID',
  },
];

export const repHistoryKey = [
  {
    label: 'Processed Date',
    varName: 'ProcessedDate',
    valueMask: 'date',
  },
  {
    label: 'Status',
    varName: 'ReviewStatus',
    key: statusKey,
  },
  {
    label: 'Alert Count',
    varName: 'AlertCount',
  },
  {
    label: 'Reviewer ID',
    varName: 'ReviewerID',
  },
  {
    label: 'Reviewer Name',
    varName: 'ReviewerName',
  },
  {
    label: 'Review Date',
    varName: 'ReviewDate',
    valueMask: 'date',
  },
];
